import { render, staticRenderFns } from "./InternalAssistance.vue?vue&type=template&id=d896f2fa"
import script from "./InternalAssistance.vue?vue&type=script&lang=ts"
export * from "./InternalAssistance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports